import { CSSProperties, forwardRef, useContext } from "react";

import { Box, BoxProps } from "@/components/layout/flexbox";
import { PageSizeContext } from "@/components/layout/PageSize";

interface ScrollParentProps extends BoxProps {
  fixedWindowHeight?: boolean;
  heightOffset?: number;
  height?: number;
  style?: CSSProperties;
  children?: React.ReactNode;
  className?: string;
}

export const ScrollParent = forwardRef<HTMLDivElement, ScrollParentProps>(
  function ScrollParent(props, ref) {
    const { heightOffset = 0 } = props;
    const { windowHeight } = useContext(PageSizeContext);

    let { height } = props;

    if (windowHeight && !height) {
      height = windowHeight - heightOffset;
    }

    if (isNaN(height as number)) {
      height = undefined;
    }

    return (
      <Box
        ref={ref}
        {...props}
        style={{
          position: "relative",
          height,
          overflowY: "scroll",
          WebkitOverflowScrolling: "touch",
          ...props.style,
        }}
      />
    );
  },
);
